<template>
  <div @click="onClick" role="progressbar" :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null]" :style="{width}" :is="tag">
    <table-layout y-align="middle" v-if="type === 'linear'">
      <row>
        <cell v-if="iconLeft" x-align="center" :class="['bcq-progressbar-icon-cell']">
          <icon :provider="iconProvider" :name="iconLeft" :color="iconColor" :color-lightness="iconColorLightness" />
        </cell>
        <cell>
          <div :style="trackCss" :class="[`shadow-${elevation}`, indeterminate ? 'bcq-progressbar-indeterminate' : null, 'bcq-progressbar-track', 'overflow-hidden', 'relative', setBgColor('trackBgColor', 'trackBgColorLightness')]">
            <div :class="[setBgColor('progressBgColor', 'progressBgColorLightness'), 'absolute', `${reversed ? 'right' : 'left'}-0`, 'top-0', 'bottom-0', 'transition-all', 'duration-500']" :style="progressCss" />
          </div>
        </cell>
        <cell v-if="iconRight" x-align="center" :class="['bcq-progressbar-icon-cell']">
          <icon :provider="iconProvider" :name="iconRight" :color="iconColor" :color-lightness="iconColorLightness" />
        </cell>
      </row>
    </table-layout>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import Utils from '../../mixins/utils'

export default {
  name: 'Progressbar',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('progressbar', ['block', 'cursor-default', 'outline-none'])
    }
  },
  props: {
    iconLeft: {
      type: String
    },
    iconRight: {
      type: String
    },
    iconColor: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    indeterminate: {
      type: Boolean
    },
    rounded: {
      type: Boolean
    },
    value: {
      type: Number,
      default: 0
    },
    comparator: {
      type: Number,
      default: 100
    },
    width: {
      type: String
    },
    tag: {
      type: String,
      default: 'div'
    },
    height: {
      type: String,
      default: '4px'
    },
    reversed: {
      type: Boolean
    },
    progressBgColor: {
      type: String,
      default: 'gray'
    },
    percentageToFixed: {
      type: Number,
      default: 0
    },
    trackBgColor: {
      type: String,
      default: 'gray'
    },
    type: {
      type: String,
      default: 'linear',
      validator: value => {
        return ['linear', 'circular'].includes(value)
      }
    },
    trackBgColorLightness: {
      type: [Number, String],
      default: 300,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    progressBgColorLightness: {
      type: [Number, String],
      default: 600,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    }
  },
  watch: {
    value () {
      this.$emit('progress', this.value)
    }
  },
  computed: {
    progressCss () {
      return {
        height: this.height,
        width: this.getPercentage()
      }
    },
    trackCss () {
      const height = this.height
      return {
        height,
        borderRadius: this.rounded ? `${parseInt(height, 10) / 2}px` : null
      }
    }
  },
  methods: {
    getPercentage () {
      return `${(100 * this.value / this.comparator).toFixed(this.percentageToFixed)}%`
    },
    onClick () {
      this.$emit('click', {
        value: this.value,
        comparator: this.comparator,
        indeterminate: this.indeterminate
      })
    }
  }
}
</script>
<style>
.bcq-progressbar .bcq-progressbar-icon-cell
{
  width: 32px;
}

.bcq-progressbar .bcq-progressbar-indeterminate > div
{
  animation: indeterminate 1s linear infinite;
}

@keyframes indeterminate
{
  0%
  {
    width: 0;
    opacity: 1;
  }

  100%
  {
    width: 100%;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/progressbar/progressbar.vue